import React from 'react'
import Banner from '../others/Banner'
import CoinsTable from '../others/CoinsTable'

function Home() {
  return (
    <>
     <Banner/>
     <CoinsTable/>
    </>
  )
}

export default Home